var site = site || {};
site.inits = site.inits || [];

site.iframeModal = {
	init: function () {
		var $urls = $('.category.icons .item > a:not([target])'),
			$iframe = $('#displayOverlay iframe'),
			$closeButton = $('#display__close'),
			$body = $('body');
		$urls.on('click', function (e) {
			e.preventDefault();
			var $iframeSrc = $iframe.attr('src'),
				$buttonHref = $(this).attr('href');
			if ($buttonHref.length && $buttonHref[0] === '/') {
				$buttonHref = $buttonHref + '#breadcrumbs';
			}
			if ($buttonHref !== $iframeSrc) {
				$iframe.attr('src', $buttonHref);
			}
			$body.addClass('iframeOpen');
		});
		var $touchmoved;
		$urls.on('touchend', function (e) {
			if (!$touchmoved) {
				$(this).click();
			}
		}).on('touchmove', function () {
			$touchmoved = true;
		}).on('touchstart', function () {
			$touchmoved = false;
		});
		$closeButton.on('click', function () {
			$body.removeClass('iframeOpen');
		});
		$(document).keyup(function (e) {
			if (e.key === "Escape") {
				site.iframeModal.close();
			}
		});
		$(document).mouseup(function (e) {
			var container = $('#displayOverlay iframe');
			if ($body.is('.iframeOpen') && !container.is(e.target) && container.has(e.target).length === 0) {
				site.iframeModal.close();
			}
		});
	},

	close: function () {
		var $iframe = $('#displayOverlay iframe'),
			$body = $('body');
		$body.removeClass('iframeOpen');
		$iframe.attr('src', '');
	}
};

site.informationDisplayTilt = {
	init: function () {
		var $urls = $('.category.icons.upplysingaskjar .item');
		if (!$urls.length) {
			return;
		}
		$urls.tilt({
			'glare': true,
			'maxGlare': .2
		});
	}
};

if (document.body.classList.contains('upplysingaskjar')) {
// Run all the inits \o/
	$(function () {
		$.each(site.inits, function (i, value) {
			var fun = new Function(value);
			fun();
		});

		site.iframeModal.init();
		site.informationDisplayTilt.init();
	});
}
